<template>
  <div>
    <Companies :key="keyComp" />
  </div>
</template>

<script>
import Companies from "../../components/companyDetail/index.vue";
export default {
  components: {
    Companies,
  },
  data(){
    return {
      keyComp: 1
    }
  },
  watch: {
    '$route'(){
      this.keyComp ++;
    },
  }
};
</script>

<style>
</style>